import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Create Package Dropdown Component
 * Dropdown for selecting a box type to create a new package
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
export var CreatePackageDropdown = function (_a) {
    var boxTypes = _a.boxTypes, onBoxTypeSelect = _a.onBoxTypeSelect, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    return (_jsx(Dropdown, { title: t('Create Package'), placeholder: t('Select One'), searchable: true, allowClear: true, data: boxTypes, isDisabled: isDisabled, onChange: function (value) {
            if (value) {
                onBoxTypeSelect(value);
            }
        } }, void 0));
};
export default CreatePackageDropdown;
